import { render, staticRenderFns } from "./OpenDetails.vue?vue&type=template&id=751da1c4&"
import script from "./OpenDetails.vue?vue&type=script&lang=ts&"
export * from "./OpenDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('751da1c4')) {
      api.createRecord('751da1c4', component.options)
    } else {
      api.reload('751da1c4', component.options)
    }
    module.hot.accept("./OpenDetails.vue?vue&type=template&id=751da1c4&", function () {
      api.rerender('751da1c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/assets/Inquiry/OpenDetails.vue"
export default component.exports